<template>
	<v-app>
		<v-navigation-drawer persistent :mini-variant="miniVariant" clipped enable-resize-watcher fixed app>
			<v-list>
				<v-list-item value="true" v-for="(item, i) in items" :key="i" :to="item.link">
					<v-list-item-action>
						<v-icon v-html="item.icon"></v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title v-text="item.title"></v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-app-bar app :clipped-left="clipped" color="info" dark>
			<v-btn class="d-none d-lg-flex" icon @click.stop="miniVariant = !miniVariant">
				<v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
			</v-btn>

			<v-toolbar-title v-text="title">This is the title </v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon>
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
			<v-menu bottom offset-y>
				<template v-slot:activator="{ on }">
					<v-btn dark icon v-on="on">
						<v-icon>account_box</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(item, i) in menuitems" :key="i" @click="">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-btn icon>
				<v-icon>power_settings_new</v-icon>
			</v-btn>
		</v-app-bar>

		<v-content>
			<router-view />
			<div class="upgrade-dialog" v-if="prompt">
				<div class="upgrade-dialog__message">
					A new version is found. Refresh to load it?
				</div>
				<div class="upgrade-dialog__button upgrade-dialog__button--accept" @click="upgrade">
					Refresh
				</div>
				<div class="upgrade-dialog__button upgrade-dialog__button--cancel" @click="prompt = false">
					Later
				</div>
			</div>
		</v-content>

		<v-footer app>
			<span>&nbsp;#36058&nbsp;&copy;&nbsp;2020</span>
		</v-footer>
	</v-app>
</template>

<script>
import { msalMixin } from "vue-msal";

export default {
	name: "App",

	mixins: [msalMixin],
	computed: {
		user() {
			let user = null;
			if (this.msal.isAuthenticated) {
				// Note that the dollar sign ($) is missing from this.msal
				user = {
					...this.msal.user,
					profile: {},
				};
				if (this.msal.graph && this.msal.graph.profile) {
					user.profile = this.msal.graph.profile;
				}
			}
			console.log(user);
			return user;
		},
	},

	data: () => ({
		prompt: false,
		clipped: true,
		drawer: true,
		miniVariant: false,
		right: true,
		title: "PDC Functions",
		items: [
			{ title: "Home", icon: "home", link: "/" },
			{ title: "Counter", icon: "touch_app", link: "/counter" },
			{ title: "Fetch data", icon: "get_app", link: "/fetch-data" },
		],
		menuitems: [{ title: "Click Me" }, { title: "Click Me" }, { title: "Click Me" }, { title: "Click Me 2" }],
		//
	}),
	created() {
		if (this.$workbox) {
			this.$workbox.addEventListener("waiting", () => {
				this.prompt = true;
			});
		}
	},
	methods: {
		async upgrade() {
			this.prompt = false;
			await this.$workbox.messageSW({ type: "SKIP_WAITING" });
		},
	},
};
</script>
<style lang="scss">
#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
#nav {
	padding: 30px;
	a {
		font-weight: bold;
		color: #2c3e50;
		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
.upgrade-dialog {
	position: fixed;
	bottom: 24px;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 4px;
	box-sizing: border-box;
	padding: 8px 12px;
	color: white;
	background-color: #2c3e50;
	box-shadow: 0 4px 4px rgba(#2c3e50, 0.4);
	display: grid;
	grid-template-columns: 1fr max-content;
	gap: 8px;
	&__message {
		grid-column: 1 / 3;
	}
	&__button {
		padding: 0 8px;
		height: 36px;
		line-height: 36px;
		font-weight: bold;
		cursor: pointer;
		user-select: none;
		&--accept {
			justify-self: end;
		}
	}
}
</style>
